<script>
// 客户搜索选择
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import _ from "lodash";
import {getCustomers} from "@/helpers/common-service";

export default {
  props: {
    selectedCustomerId: {
      type: [String, Number],
      default: null
    },
    canDeselect: {
      type: Boolean,
      default: false
    },
    canClear: {
      type: Boolean,
      default: false,
    },
    isInvalid: {
      type: [Boolean, Number],
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      // 可选的客户列表，动态搜索
      customers: [],
      // 当前选择的客户ID
      customer: null,
      loading: false,
    }
  },
  mounted() {
    this.getCustomers('')
  },
  methods: {
    // 搜客户
    debouncedSearchCustomer: _.debounce(function (search) {
      this.getCustomers(search)
    }, 500),
    getCustomers(search) {
      this.loading = true
      getCustomers(search).then(res => {
        this.customers = res
        this.loading = false
      })
    },
    // 选择客户后自动填充其他相关字段
    setCurrentCustomer(value) {
      const currentCustomer = _.find(this.customers, ['id', value])
      if (value && !currentCustomer) {
        console.log('顾客列表中没有选中的值：', value)
      }
      this.$emit('changed', currentCustomer)
    },
  },
  components: {
    Multiselect,
  },
  watch: {
    selectedCustomerId: {
      immediate: true,
      handler(val) {
        this.customer = val
      }
    }
  }
}
</script>
<template>
<!--  如果搜索要调接口：@search-change="debouncedSearchCustomer"-->
  <Multiselect class="form-control"
               :class="isInvalid ? 'is-invalid' : ''"
               ref="customerSelect"
               v-model="customer"
               :placeholder="this.$t('serviceCompany.company_name')"
               value-prop="id"
               label="name"
               @change="setCurrentCustomer"
               :close-on-select="true"
               :searchable="true"
               :create-option="false"
               :can-deselect="canDeselect"
               :can-clear="canClear"
               :options="customers"
               :disabled="isDisabled"
               :loading="loading"
  />

</template>
